import * as PIXI from "pixi.js";
import { UIButton } from "./UIButton";
import { GameEngine } from "src/server/GameEngine";

export class CheatPopup extends PIXI.Container {
    private background: PIXI.Graphics;
    private buttons: UIButton[] = [];
    private reels: number;

    constructor() {
        super();
        this.reels = 3;

        const width = 700;
        const height = 700;
        const title = new PIXI.Text({
            text: "Cheats",
            style: {
                fill: "0xff8531",
                fontWeight: "bold",
                fontSize: 30,
            }
        });
        title.anchor.set(0.5);
        title.y = -300;
        // Create the popup background
        this.background = new PIXI.Graphics();
        this.background.roundRect(-width / 2, -height / 2, width, height, 20); // Rounded rectangle
        this.background.fill(0x000000); // Dark gray
        this.background.alpha = 0.85;
        this.background.interactive = true;

        this.addChild(this.background);
        this.addChild(title);

        this.setCheats(Object.keys(GameEngine.getInstance().getLoadResponse().rigData));
    }

    show () {
        this.visible = true;
    }

    hide () {
        this.visible = false;
    }

    // Method to set bet amounts dynamically
    public setCheats(cheats: string[]): void {
        // Clear existing buttons
        this.buttons.forEach((button) => this.removeChild(button));
        this.buttons = [];

        // Determine rows based on the number of bets and fixed reels
        const rows = Math.ceil(cheats.length / this.reels);

        const padding = 20; // Padding between buttons
        const buttonWidth = 200;
        const buttonHeight = UIButton.HEIGHT;

        // Calculate total width of the buttons and padding for horizontal centering
        const totalWidth = this.reels * buttonWidth + (this.reels - 1) * padding;
        const startX = -totalWidth / 2 + buttonWidth / 2; // Center horizontally by adjusting X position

        // Calculate the vertical start position to center the buttons
        const totalHeight = rows * buttonHeight + (rows - 1) * padding;
        const startY = -totalHeight / 2 + 50; // Center vertically by adjusting Y position

        // Create buttons dynamically based on bets array
        cheats.forEach((cheat, index) => {
            const row = Math.floor(index / this.reels);
            const col = index % this.reels;

            const x = startX + col * (buttonWidth + padding);
            const y = startY + row * (buttonHeight + padding);

            const button = new UIButton(cheat, buttonWidth, buttonHeight);
            button.setData(cheat);
            button.position.set(x, y);

            // Listen to the 'onSelect' event for each button
            button.on('onSelect', this.onCheatButtonSelect, this);

            this.addChild(button);
            this.buttons.push(button);
        });
    }

    // Handle bet button selection
    private onCheatButtonSelect(selectedButton: UIButton): void {
        // If a button is already selected, unselect it
        this.emit('rigSelected', selectedButton.getData());
    }
}
